import styled from 'styled-components';

export const StyledToolbarWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({open}) => open ? '1fr' : '73px 1fr'};
`;

export const StyledToolbarContent = styled.div`
  height: 100px;
  padding: 0 25px;
  display: grid;
  grid-template-columns: 55px 245px auto;
  grid-gap: 20px;
  align-items: center;
  justify-content: end;
  .toolbar-search {
    &__text {
    & > div {
        input {
            background: rgba(255 255 255 / 0.25) !important;
          &:focus {
            background: rgba(255 255 255 / 1) !important;
          }
        }
      }
    }
    @media screen and (max-width: 599px) {
      display: none;
    }
  }
  @media screen and (max-width: 1200px) {
    grid-gap: 25px;
  }
  @media screen and (max-width: 992px) {
    padding: 0 15px;
  }
  @media screen and (max-width: 599px) {
    height: 60px;
    grid-template-columns: repeat(2, 35px) auto;
    grid-gap: 12px;
  }
`;

export const StyledToolbarButton = styled.button`
  height: 50px;
  width: 50px;
  color: #fff;
  font-size: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: rgba(22, 41, 84 ,0.3);
  border: none;
  border-radius: 50%;
  outline: none;
  transition: all .1s ease;
  &:hover {
    background: rgba(22, 41, 84 ,0.8);
    color: #fff !important;
  }
  
  @media screen and (max-width: 600px) {
    width: 35px;
    height: 35px;
    font-size: 16px;
    
    &:not(:first-child) {
      display: none;
    }
  }
`;

export const StyledToolbarButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 15px;
  
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledToolbarUserInfo = styled.div`
  display: grid;
  grid-template-columns: 60px auto 35px;
  grid-gap: 15px;
  align-items: center;
  @media screen and (max-width: 768px) {
    grid-template-columns: 60px 35px;
    justify-content: end;
  }
  @media screen and (max-width: 599px) {
    grid-template-columns: repeat(2, 35px);
    grid-gap: 5px;
  }
`;

export const StyledUserPhoto = styled.div`
  height: 60px;
  width: 60px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 7px 14px rgba(84 99 132 / 30%);
  overflow: hidden;
  .user-photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
  }
  span {
    color: #162954;
    font-size: 26px;
    font-weight: 700;
    text-align: center;
    text-transform: capitalize;
  }
  @media screen and (max-width: 599px) {
    height: 35px;
    width: 35px;
    box-shadow: 0 3px 7px rgba(84 99 132 / 20%);
    span {
      font-size: 18px;
    }
  }
`;

export const StyledUserDescription = styled.div`
  max-width: 200px;

  @media screen and (max-width: 992px) {
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const StyledUserName = styled.div`
  max-width: 200px;
  color: #162954;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  text-transform: lowercase;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  @media screen and (max-width: 992px) {
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const StyledUserRole = styled.div`
  max-width: 200px;
  color: rgba(22, 41, 84, 0.75);
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const StyledDropdownBtn = styled.button`
  width: 35px;
  height: 35px;
  background-color: transparent;
  border: none;
  outline: none;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  &:hover {
    color: #162954;
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const StyledDropdownItem = styled.button`
  width: 100%;
  color: #5a5a5a;
  display: grid;
  grid-template-columns: 25px 1fr;
  grid-gap: 10px;
  text-align: left;
  background-color: transparent;
  border: none;
  outline: none;  
  cursor: pointer;
  span {
    color: #162954;
    font-size: 22px;
  }
`;

export const StyledSidebarBtn = styled.button`
  width: 100%;
  color: #909090;
  display: ${({open}) => open ? 'none' : 'inline-flex'};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: none;
  outline: none;
  transition: all .3s ease;
  .toolbar-logo__drawer-icon {
    width: 45px;
    padding-bottom: 5px;
  }
  &:before {
    content: '\\e922';
    height: 15px;
    width: 15px;
    margin-top: -7px;
    font-family: 'cp-icons', serif;
    position: absolute;
    top: 50%;
    right: 0;
    @media screen and (max-width: 599px) {
      content: '\\e917';
      height: 18px;
      width: 18px;
      margin-top: -9px;
      color: #162954;
      font-size: 18px;
      right: -10px;
    }
  }
  &:hover {
   transform: scale(1.05);
  }
  @media screen and (max-width: 992px) {
    .toolbar-logo__drawer-icon {
      width: 30px;
    }
  }
  @media screen and (max-width: 960px) {
    width: 64px;
  }
`;